import { asset } from '../asset';
import { AssetData } from '../asset/types';
import { defaultMapper } from '../default-mapper';
import { multiAsset } from '../multi-assets/multi-asset';
import { multiLink } from '../multi-link';

export const getMappedProps = (key: string, blok: AssetData): Record<string, string> => {
  if (Array.isArray(blok) && blok.length && typeof blok[0].filename === 'string') {
    return multiAsset(key, blok);
  }
  if (blok.fieldtype === 'asset') {
    return asset(key, blok);
  }
  if (blok.fieldtype === 'multilink') {
    return multiLink(key, blok as any);
  }

  return defaultMapper(key, blok);
};
